import { useNavigate, useSearchParams } from "react-router-dom";

import { Header } from "@/app/modules/Navigation";
import { PageLoader } from "@/components";
import { useAppProperties } from "@/hooks";
import { useAmityAuth, useCommunityGroups } from "@/providers/context";
import { slugify } from "@/utils";

import { CommunityFeed, CommunityGroups, EmptyScreen } from "./components";
import { SEARCH_PARAM } from "./const";
import { CommunityFeedProvider } from "./providers/CommunityFeedProvider";

export const CommunityScreen = () => {
  const navigate = useNavigate();
  const {
    authState,
    communityTabName,
    isGlobalBanned,
    isError,
    isLoading,
    userIsSubscribed,
  } = useAmityAuth();
  const { communityGroupsEnabled } = useAppProperties();

  const { groups, isError: groupsIsError, activeGroup } = useCommunityGroups();

  const [searchParams] = useSearchParams();
  const query = searchParams.get(SEARCH_PARAM);

  if (activeGroup && userIsSubscribed) {
    return (
      <CommunityFeedProvider group={activeGroup} key={query}>
        <CommunityFeed />
      </CommunityFeedProvider>
    );
  }

  // If groups are not enabled, redirect to main community to skip CommunityGroups screen
  if (!communityGroupsEnabled && groups?.joined && groups.joined.length > 0) {
    navigate(`/community/${slugify(groups.joined[0].Name)}`);
  }

  return (
    <div className="h-full">
      <Header
        className="px-7"
        content={<div className="h5-bold">{communityTabName}</div>}
      />
      {!userIsSubscribed ? (
        <EmptyScreen screenType="locked" />
      ) : isGlobalBanned ? (
        <EmptyScreen screenType="banned" />
      ) : isLoading ? (
        <PageLoader />
      ) : isError || groupsIsError || !authState?.authenticatedUser ? (
        <EmptyScreen screenType="error" />
      ) : (
        <CommunityGroups />
      )}
    </div>
  );
};
